// src/services/supportService.js
import api from "./api";

/**
 * Envia uma mensagem de suporte/sugestão para a API.
 *
 * Espera um objeto:
 * {
 *   type: 'support' | 'suggestion',
 *   subject: string,
 *   message: string
 * }
 */
export function sendSupportMessage(data) {
  return api.post("/support/send", data);
}
